import { render, staticRenderFns } from "./BmTopicWorldsOverview.vue?vue&type=template&id=2e8b45e6&scoped=true&"
import script from "./BmTopicWorldsOverview.vue?vue&type=script&lang=js&"
export * from "./BmTopicWorldsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b45e6",
  null
  
)

export default component.exports